import React from 'react'

export default function UpgradeTransferRules() {
  return (
    <div>upgradeTransferRules</div>
  )
}
